export default __webpack_public_path__ + "static/media/V370MAND1.e879d700.pdf";